// import { useState } from "react";
// import "./logo_cards.css";
// import LogoCardsTitle from "../Logo-Cards-Title/LogoCardsTitle";
// import { MockImages } from "./MockData";
// import { Link } from "react-router-dom";
// import { IoIosArrowDown } from "react-icons/io";

// const LogoCards = () => {
//   const [selectedIndex, setSelectedIndex] = useState(null);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [selectedCompany, setSelectedCompany] = useState("");

//   const openImagePopup = (index, e) => {
//     e.preventDefault();
//     setSelectedIndex(index);
//     setSelectedImage(MockImages[index].img);
//     setSelectedCompany(MockImages[index].companyName);
//   };

//   const closeImagePopup = () => {
//     setSelectedIndex(null);
//     setSelectedImage(null);
//     setSelectedCompany("");
//   };
  
//   const showNextImage = (e) => {
//     e.stopPropagation();
//     const newIndex = (selectedIndex + 1) % MockImages.length;
//     setSelectedIndex(newIndex);
//     setSelectedImage(MockImages[newIndex].img);
//     setSelectedCompany(MockImages[newIndex].companyName);
//   };
  
//   const showPrevImage = (e) => {
//     e.stopPropagation();
//     const newIndex = (selectedIndex - 1 + MockImages.length) % MockImages.length;
//     setSelectedIndex(newIndex);
//     setSelectedImage(MockImages[newIndex].img);
//     setSelectedCompany(MockImages[newIndex].companyName);
//   };

//   return (
//     <>
//       <div className="logo_cards_container">
//         <LogoCardsTitle heading="Our Recent Works" />
//         <div className="logo_cards_wrapper">
//           {MockImages.map((item, index) => (
//             <div key={index}>
//               <div onClick={(e) => openImagePopup(index, e)} style={{ cursor: "pointer" }}>
//                 <div className="card_image_contianer">
//                   <img className="card_image" src={item.img} alt={item.companyName || "Work image"}></img>

//                   <div className="arrow_container">
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="1.2rem"
//                       height="1.2rem"
//                       viewBox="0 0 24 24"
//                     >
//                       <rect width="24" height="24" fill="none" />
//                       <path
//                         fill="white"
//                         d="M8.46 6.3a.75.75 0 1 0 0 1.5h6.68l-8.62 8.62a.75.75 0 1 0 1.06 1.06l8.62-8.62v6.68a.75.75 0 0 0 1.5 0V7.05a.8.8 0 0 0-.06-.29a.76.76 0 0 0-.64-.46Z"
//                       />
//                     </svg>
//                   </div>
//                 </div>
//                 <h3>{item.companyName}</h3>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Image show*/}
//         {selectedImage && (
//           <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4" onClick={closeImagePopup}>
//             <div className="relative" onClick={(e) => e.stopPropagation()}>
//               {/* Close*/}
//               <button 
//                 onClick={closeImagePopup}
//                 className="absolute top-2 right-2 bg-black bg-opacity-50 text-white rounded-full p-2 hover:bg-opacity-70 transition-opacity duration-200 z-10"
//               >
//                 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                   <line x1="18" y1="6" x2="6" y2="18"></line>
//                   <line x1="6" y1="6" x2="18" y2="18"></line>
//                 </svg>
//               </button>
              
//               <button 
//                 onClick={showPrevImage}
//                 className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white rounded-full p-3 hover:bg-opacity-70 transition-opacity duration-200 z-10"
//               >
//                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                   <polyline points="15 18 9 12 15 6"></polyline>
//                 </svg>
//               </button>
              
//               <img
//                 src={selectedImage}
//                 alt={selectedCompany || "Enlarged image"}
//                 className="max-h-screen max-w-full object-contain"
//               />
              

//               <button 
//                 onClick={showNextImage}
//                 className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white rounded-full p-3 hover:bg-opacity-70 transition-opacity duration-200 z-10"
//               >
//                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                   <polyline points="9 18 15 12 9 6"></polyline>
//                 </svg>
//               </button>
//             </div>
//           </div>
//         )}

//         <div className="gradient_container">
//           <Link to="/works">
//             <button className="text-xl flex items-center bg-gradient-to-r from-[#E10B7B] via-[#652D90 ] to-[#1C85C7] text-white font-medium">View more <IoIosArrowDown className="h-5 w-5 mt-1 ml-2" />
//             </button>
//           </Link>
//         </div>
//       </div>
//     </>
//   );
// };

// export default LogoCards;

import { useState } from "react";
import { Link } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { MockImages } from "./MockData";

const LogoCardsTitle = ({ heading }) => (
  <div className="text-left mb-8 md:mb-12">
     <h1
          className="lg:text-5xl md:text-3xl text-2xl font-bold text-center"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          Our Recent{" "}
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#E10B7B] via-[#652D90 ] to-[#1C85C7] animate-bounce">
            Works
          </span>
          
        </h1>
  </div>
);

const LogoCards = () => {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState("");

  const openImagePopup = (index, e) => {
    e.preventDefault();
    setSelectedIndex(index);
    setSelectedImage(MockImages[index].img);
    setSelectedCompany(MockImages[index].companyName);
  };

  const closeImagePopup = () => {
    setSelectedIndex(null);
    setSelectedImage(null);
    setSelectedCompany("");
  };
  
  const showNextImage = (e) => {
    e.stopPropagation();
    const newIndex = (selectedIndex + 1) % MockImages.length;
    setSelectedIndex(newIndex);
    setSelectedImage(MockImages[newIndex].img);
    setSelectedCompany(MockImages[newIndex].companyName);
  };
  
  const showPrevImage = (e) => {
    e.stopPropagation();
    const newIndex = (selectedIndex - 1 + MockImages.length) % MockImages.length;
    setSelectedIndex(newIndex);
    setSelectedImage(MockImages[newIndex].img);
    setSelectedCompany(MockImages[newIndex].companyName);
  };
  
  const getGridClasses = () => {
    if (MockImages.length === 2) {
      return "grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 px-4 sm:px-8 md:px-16 lg:px-32";
    } else if (MockImages.length === 1) {
      return "grid-cols-1 max-w-md mx-auto";
    } else {
      return "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4";
    }
  };

  return (
    <div className="w-full px-6 py-8 md:py-12 lg:py-16">
      <LogoCardsTitle heading="Our Recent Works" />
      
      <div className={`grid ${getGridClasses()} gap-2 sm:gap-6 md:gap-4`}>
        {MockImages.map((item, index) => (
          <div
            key={index}
            className="flex flex-col max-w-xs w-full mx-auto transition-all duration-300 hover:scale-105 hover:shadow-lg rounded-lg overflow-hidden"
          >
            <div
              className="relative group w-full h-64 sm:h-72 rounded-lg overflow-hidden cursor-pointer"
              onClick={(e) => openImagePopup(index, e)}
            >
              <img
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                src={item.img}
                alt={item.companyName || "Work image"}
              />
              <div className="absolute bottom-4 right-4 bg-black bg-opacity-50 p-2 rounded-full group-hover:scale-110 transition-transform duration-300">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  className="text-white"
                  viewBox="0 0 24 24"
                >
                  <rect width="24" height="24" fill="none" />
                  <path
                    fill="currentColor"
                    d="M8.46 6.3a.75.75 0 1 0 0 1.5h6.68l-8.62 8.62a.75.75 0 1 0 1.06 1.06l8.62-8.62v6.68a.75.75 0 0 0 1.5 0V7.05a.8.8 0 0 0-.06-.29a.76.76 0 0 0-.64-.46Z"
                  />
                </svg>
              </div>
            </div>
            <h3 className="text-center py-4 font-medium text-lg">{item.companyName}</h3>
          </div>
        ))}
      </div>

      <div className="flex mt-8 md:mt-12 justify-center relative z-10">
        <Link to="/works" className="inline-block">
          <button 
            className="flex items-center px-6 py-3 rounded-lg bg-gradient-to-r from-pink-600 via-purple-600 to-blue-500 text-white font-medium text-lg transition-all duration-300 hover:scale-105 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50"
            aria-label="View more works"
          >
            View more <IoIosArrowDown className="h-5 w-5 ml-2" />
          </button>
        </Link>
      </div>

      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-4"
          onClick={closeImagePopup}
        >
          <div className="relative max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
            <button
              onClick={closeImagePopup}
              className="absolute top-2 right-2 bg-black bg-opacity-50 text-white rounded-full p-2 hover:bg-opacity-70 transition-opacity duration-200 z-10"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>

            <button
              onClick={showPrevImage}
              className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white rounded-full p-2 md:p-3 hover:bg-opacity-70 transition-opacity duration-200 z-10"
              aria-label="Previous image"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
            </button>

            <div className="flex flex-col items-center">
              <img
                src={selectedImage}
                alt={selectedCompany || "Enlarged image"}
                className="max-h-[80vh] max-w-full object-contain"
              />
              {selectedCompany && (
                <p className="bg-black bg-opacity-50 text-white py-2 px-4 rounded-lg mt-2 text-center">
                  {selectedCompany}
                </p>
              )}
            </div>

            <button
              onClick={showNextImage}
              className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-50 text-white rounded-full p-2 md:p-3 hover:bg-opacity-70 transition-opacity duration-200 z-10"
              aria-label="Next image"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </button>
          </div>
        </div>
      )}

    </div>
  );
};

export default LogoCards;